// 第三方跳转链接地址
const domain =
  process.env.BUILD_ENV === 'production'
    ? 'https://www.tradeup.com'
    : process.env.BUILD_ENV === 'preview'
    ? 'https://www-staging.tradeup.com'
    : 'https://tradeup-dev.tigerfintech.com'

// 开户地址
export const OPEN_ACCOUNT_LINK = `${domain}/accounts/open/personalInfo`

// 入金地址
export const DEPOSIT_LINK = `${domain}/personal/transfer/deposit/way`

// 提现地址
export const WITHDRAW_LINK = `${domain}/personal/transfer/withdraw/way`

// 服务条款
export const TERMS_CONDITION_LINK = `${domain}/disclaimers`

// 两步验证开启地址
export const TWO_STEP_VERIFY_LINK = `${domain}/personal/account/step/info`

// 修改手机号
export const MODIFY_PHONE_LINK = `${domain}/safe/changephone/check`

// 修改邮箱地址
export const MODIFY_EMAIL_LINK = `${domain}/safe/changeemail/check`

// 修改邮箱密码地址
export const MODIFY_EMAIL_PWD_LINK = `${domain}/retrive/check?loginType=email`

// 修改手机密码地址
export const MODIFY_PHONE_PWD_LINK = `${domain}/retrive/check?loginType=phone`

// 帮助页面地址
export const HELP_LINK = `${domain}/help`

// 用户协议地址
export const USER_AGREEMENT_LINK = `${domain}/statement/signup_service`

// 隐私政策地址
export const PRIVACY_LINK = `${domain}/agreement/206`

// 模拟账户协议
export const VIRTUAL_CONTRACT_LINK = `${domain}/statement/USA-Marscopapertrading`

// 官网地址
export const PORTAL_LINK = domain

// 税务报表地址
export const TAXFORM_LINK = `${domain}/personal/viewdoc/tax`
